import { NoteDay } from '../constants/Note';
import type { User } from '../firebase/firebase';
import {
	defaultCloudFunctionServices,
	makeCloudFunctionRequestReturnSuccessStatus,
} from './BaseCloudFunctionRequests';
import { HTTPSCloudFunctionURLs } from './HTTPSCloudFunctionURLs';

export type CreateNoteBody = {
	timesheetID: string;
	note: string;
	day: NoteDay;
};

export const createTimesheetNote = async (
	abortSignal: AbortSignal,
	user: User,
	timesheetID: string,
	day: NoteDay,
	note: string,
): Promise<boolean> => {
	return await makeCloudFunctionRequestReturnSuccessStatus<CreateNoteBody>({
		abortSignal,
		user,
		url: HTTPSCloudFunctionURLs.CreateTimesheetNote,
		method: 'POST',
		services: defaultCloudFunctionServices,
		body: {
			timesheetID,
			day,
			note,
		},
	});
};
